import moment from 'moment';
import now from 'moment';

export function getNoun (number) {
  let n = Math.abs(number);
  n %= 100;
  if (n >= 5 && n <= 20) {
    return ' дней';
  }
  n %= 10;
  if (n === 1) {
    return ' день';
  }
  if (n >= 2 && n <= 4) {
    return ' дня';
  }
  return ' дней';
}

export function calculateTimeleft (date) {
  if (date === null) {
    return null;
  }
  const today = new Date(now());
  const dateStop = new Date(date);
  const milliseconds = dateStop.getTime() - today.getTime();
  const seconds = Math.floor((milliseconds / 1000) % 60);
  const minutes = Math.floor((milliseconds / 1000 / 60) % 60);
  const hours = Math.floor((milliseconds / 1000 / 60 / 60) % 24);
  const days = Math.floor((milliseconds / 1000 / 60 / 60) % 24);

  if (seconds <= -1) {
    return null;
  } 
  else if (days >= 7) {
    return dateStop;
  } 
  else if (days < 7) {
    return days !== 0 ? days + ' дн ' + hours + ' ч ' + minutes + ' мин ' : hours + ' ч ' + minutes + ' мин ';
  }
}

export function classToTarification (delta) {
  if (delta < 0) {
    return 'red';
  } 
  else {
    return 'green';
  }
}

export function formatStringDate (stringValue) {
  if (stringValue === null)
    return null;
  return moment(new Date(stringValue)).format('YYYY-MM-DD');
}

export function formatStringDateUserFriendly (stringValue) {
  if (stringValue === null)
    return null;
  return new Date(Date.parse(stringValue)).toLocaleDateString('ru-RU', {
    day: 'numeric',
    month: 'long'
  });
}

export function formatStringDateUserFriendlyAndGetWeekday (stringValue) {
  if (stringValue === null)
    return null;
  return new Date(Date.parse(stringValue)).toLocaleDateString('ru-RU', {
    weekday: 'short'
  });
}
export function formatStringDateTime (stringDateTime) {
  if (stringDateTime === null)
    return null;
  const asDate = new Date(stringDateTime);
  return `${asDate.toLocaleDateString()}, ${('0' + asDate.getHours()).slice(-2) + ':' + ('0' + asDate.getMinutes()).slice(-2)}`;
}

export function formatCurrency (value, locale) {
  let currency;
  switch (locale) {
    case 'ru':
      currency = 'RUB';
      break;
    case 'kz':
      currency = 'KZT';
      break;
    case 'uz':
      currency = 'UZS';
      break;
    default:
      currency = 'RUB'; 
  }

  let currencySymbol;
  switch (currency) {
    case 'RUB':
      currencySymbol = '₽';
      break;
    case 'KZT':
      currencySymbol = '₸'; 
      break;
    case 'UZS':
      currencySymbol = 'сум'; 
      break;
    default:
      currencySymbol = currency; 
  }

  let formattedValue = new Intl.NumberFormat(locale, { style: 'currency', currency: currency, minimumFractionDigits: 0 }).format(value);

  if (locale === 'uz') {
    formattedValue = formattedValue.replace(currency, '').trim() + ' ' + currencySymbol;
    formattedValue = formattedValue.replace(',', ' ');
  } 
  else {
    formattedValue = formattedValue.replace(currency, currencySymbol);
  }

  return formattedValue;
}

export function formatCard (value) {
  return new Intl.NumberFormat('ru-RU', { useGrouping: true }).format(value);
}

export function formatTimeToHoursMinutes (stringTime) {
  if (stringTime === null) 
    return null;
  // С оставшимся временем
  if (stringTime < 0) {
    stringTime = -stringTime;
    const days = stringTime / 60 / 24;
    const rdays = Math.floor(days);
    const hours = (days - rdays) * 24;
    const rhours = Math.floor(hours);
    const minutes = (hours - rhours) * 60;
    const rminutes = Math.floor(minutes);

    if (rdays !== 0) {
      if (rhours !== 0) {
        if (rminutes !== 0) {
          return rdays + ' дн ' + rhours + ' ч ' + rminutes + ' мин';
        } 
        else {
          return rdays + ' дн ' + rhours + ' ч ';
        }
      } 
      else {
        if (rminutes !== 0) {
          return rdays + ' дн ' + rminutes + ' мин';
        } 
        else {
          return rdays + ' дн';
        }
      }
    } 
    else {
      if (rhours !== 0) {
        if (rminutes !== 0) {
          return rhours + ' ч ' + rminutes + ' мин';
        } 
        else {
          return rhours + ' ч ';
        }
      } 
      else {
        if (rminutes !== 0) {
          if (rminutes <= 1 && rminutes > 0) {
            return 'меньше 1 мин';
          }
          return rminutes + ' мин ';
        }
      }
    }
  }
  // С превышенным временем
  const days = stringTime / 60 / 24;
  const rdays = Math.floor(days);
  const hours = (days - rdays) * 24;
  const rhours = Math.floor(hours);
  const minutes = (hours - rhours) * 60;
  const rminutes = Math.round(minutes);
  if (rdays !== 0) {
    if (rhours !== 0) {
      if (rminutes !== 0) {
        return rdays + ' дн ' + rhours + ' ч ' + rminutes + ' мин';
      } 
      else {
        return rdays + ' дн ' + rhours + ' ч ';
      }
    } 
    else {
      if (rminutes !== 0) {
        return rdays + ' дн ' + rminutes + ' мин';
      } 
      else {
        return rdays + ' дн';
      }
    }
  } 
  else {
    if (rhours !== 0) {
      if (rminutes !== 0) {
        return rhours + ' ч ' + rminutes + ' мин';
      } 
      else {
        return rhours + ' ч ';
      }
    } 
    else {
      if (rminutes !== 0) {
        if (rminutes <= 1 && rminutes > 0) {
          return 'меньше 1 мин';
        }
        return rminutes + ' мин ';
      }
    }
  }
}

export const isoDate = (value) => (new Date(value - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
export const isoLocalDateTime = (value) => (new Date(value - (new Date()).getTimezoneOffset() * 60000)).toISOString();

export function daysToExpire (date) {
  const today = new Date(now());
  const dateStop = new Date(date);
  var timeDiff = Math.abs(dateStop.getTime() - today.getTime());
  var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
  return diffDays;
}
